import { Union, Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { union_type, string_type, list_type, record_type, class_type, int32_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { LoadState$2, LoadState$2$reflection } from "../../Global.js";
import { createReducer, createAction } from "../Redux.js";

export class PendingDirectInvoice extends Record {
    constructor(InvoiceeNr, InvoiceeBatchId, InvoiceDate) {
        super();
        this.InvoiceeNr = (InvoiceeNr | 0);
        this.InvoiceeBatchId = (InvoiceeBatchId | 0);
        this.InvoiceDate = InvoiceDate;
    }
}

export function PendingDirectInvoice$reflection() {
    return record_type("Redux.Reducers.DirectInvoice.PendingDirectInvoice", [], PendingDirectInvoice, () => [["InvoiceeNr", int32_type], ["InvoiceeBatchId", int32_type], ["InvoiceDate", class_type("System.DateOnly")]]);
}

export class DirectInvoiceState extends Record {
    constructor(PendingDirectInvoices) {
        super();
        this.PendingDirectInvoices = PendingDirectInvoices;
    }
}

export function DirectInvoiceState$reflection() {
    return record_type("Redux.Reducers.DirectInvoice.DirectInvoiceState", [], DirectInvoiceState, () => [["PendingDirectInvoices", LoadState$2$reflection(list_type(PendingDirectInvoice$reflection()), string_type)]]);
}

export class DirectInvoiceAction extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["SetPendingDirectInvoices"];
    }
}

export function DirectInvoiceAction$reflection() {
    return union_type("Redux.Reducers.DirectInvoice.DirectInvoiceAction", [], DirectInvoiceAction, () => [[["Item", LoadState$2$reflection(list_type(PendingDirectInvoice$reflection()), string_type)]]]);
}

export function setPendingDirectInvoices(payload) {
    return createAction("DirectInvoiceReducer", new DirectInvoiceAction(0, payload));
}

export const initState = new DirectInvoiceState(new LoadState$2(0));

function innerReducer(state, action) {
    return new DirectInvoiceState(action.fields[0]);
}

export function reducer(stateOpt, action) {
    return createReducer("DirectInvoiceReducer", initState, stateOpt, action, innerReducer);
}

